import LiveDot from '@/components/general/Badge/LiveDot';
import { Pill } from '@/components/general/Pill';
import React from 'react';

export default function LivePill() {
  return (
    <Pill color="var(--green)" bg="var(--green-bg)">
      <LiveDot />
      استعلام زنده
    </Pill>
  );
}
